import { render } from "./pj.vue?vue&type=template&id=0aadb250"
import script from "./pj.vue?vue&type=script&lang=js"
export * from "./pj.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\pda_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__